import { useEffect, useState } from "react";
import BackBtn from "./BackBtn";

export default function Contact() {
  useEffect(() => {
    document.body.className = "search-shrink";
    return () => {
      document.body.className = "";
    };
  }, []);

  return (
    <section className="contactUs">
      <BackBtn />
      <div className="contactUsWrapper">
        <div className="contactUsWrapperLeft">
          <span className="icon">
            <svg width="24" height="24" fill="none" viewBox="4 4 16 16">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".5" d="M18.25 11C18.25 15 12 19.25 12 19.25C12 19.25 5.75 15 5.75 11C5.75 7.5 8.68629 4.75 12 4.75C15.3137 4.75 18.25 7.5 18.25 11Z"></path>
              <circle cx="12" cy="11" r="2.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".5"></circle>
            </svg>
          </span>
          <h2>Store Finder</h2>
          <h3>Find your closest branch</h3>
          <p>
            Find your nearest branch via our{" "}
            <a href="https://shop.cnw.com.au/store-finder" target="_blank">
              Store Finder
            </a>
          </p>
          <p>Turn on location services to access automatic results.</p>
          <p>Or simply input your postcode or suburb to filter your nearest branch locations.</p>
        </div>
        <div className="contactUsWrapperRight">
          <span className="icon">
            <svg width="24" height="24" fill="none" viewBox="4 4 16 16">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".5" d="M8.89286 4.75H6.06818C5.34017 4.75 4.75 5.34017 4.75 6.06818C4.75 13.3483 10.6517 19.25 17.9318 19.25C18.6598 19.25 19.25 18.6598 19.25 17.9318V15.1071L16.1429 13.0357L14.5317 14.6468C14.2519 14.9267 13.8337 15.0137 13.4821 14.8321C12.8858 14.524 11.9181 13.9452 10.9643 13.0357C9.98768 12.1045 9.41548 11.1011 9.12829 10.494C8.96734 10.1537 9.06052 9.76091 9.32669 9.49474L10.9643 7.85714L8.89286 4.75Z"></path>
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".5" d="M14 5.02936C16.4312 5.72562 18.3396 7.65944 19 10.1056"></path>
            </svg>
          </span>

          <h2>Contact Us</h2>
          <h3>Want to talk to a human?</h3>
          <p>
            You can simply call us on <a href="tel:1300 010 010">1300 010 010</a>
          </p>
          <p>
            Or reach out to us via our live chat on{" "}
            <a href="https://shop.cnw.com.au/" target="_blank">
              shop.cnw.com.au
            </a>
          </p>
          <p>
            Got a technical question about your online account? Simply email <a href="mailto:online.support@bgwgroup.com.au">online.support@bgwgroup.com.au</a>
          </p>
        </div>
      </div>
    </section>
  );
}
